/**
 * Notify Me When Available - PDP Flyout Drawer
 *
 * Moves the MST app widget (within product-info) into the drawer,
 * wrapped with product info header, description, and disclaimer.
 */

(function () {
  'use strict';

  var NOTIFY_TEXT = 'NOTIFY ME WHEN AVAILABLE';
  var DISCLAIMER = 'By signing up via text or email, you agree to receive recurring automated marketing messages and shopping cart reminders at the phone number or email provided. Consent is not a condition of purchase.';

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('notify-drawer-open');
    window.dispatchEvent(new Event('resize'));
    var closeBtn = drawer.querySelector('.notify-me-drawer__close');
    if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 300);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('notify-drawer-open');
  }

  function bindDrawerCloseEvents(drawer) {
    if (drawer._bound) return;
    drawer._bound = true;
    drawer.querySelectorAll('[data-notify-drawer-close]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer(drawer);
      });
    });
    drawer.addEventListener('click', function(e) {
      if (e.target === drawer) closeDrawer(drawer);
    });

    // Mobile: drag-to-dismiss on the content panel
    var content = drawer.querySelector('.notify-me-drawer__content');
    if (content) {
      var startY = 0;
      var currentY = 0;
      var isDragging = false;

      content.addEventListener('touchstart', function(e) {
        if (window.innerWidth >= 750) return;
        var touch = e.touches[0];
        var rect = content.getBoundingClientRect();
        // Only allow drag from top 50px (handle area)
        if (touch.clientY - rect.top > 50) return;
        startY = touch.clientY;
        currentY = startY;
        isDragging = true;
        content.style.transition = 'none';
      }, { passive: true });

      content.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        currentY = e.touches[0].clientY;
        var deltaY = currentY - startY;
        if (deltaY < 0) deltaY = 0;
        content.style.transform = 'translateY(' + deltaY + 'px)';
      }, { passive: true });

      content.addEventListener('touchend', function() {
        if (!isDragging) return;
        isDragging = false;
        var deltaY = currentY - startY;
        content.style.transition = '';
        content.style.transform = '';
        if (deltaY > 80) {
          closeDrawer(drawer);
        }
      }, { passive: true });
    }
  }

  function esc(s) {
    if (!s) return '';
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function init() {
    var productInfo = document.querySelector('product-info[data-main-product]');
    if (!productInfo) return;

    var sectionId = productInfo.dataset.section;
    var drawer = document.getElementById('NotifyMeDrawer-' + sectionId);
    var drawerBody = document.getElementById('NotifyMeDrawerBody-' + sectionId);
    if (!drawer || !drawerBody) return;

    // Move drawer to body so it sits above sticky header
    document.body.appendChild(drawer);
    bindDrawerCloseEvents(drawer);

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(drawer);
    });

    // Find MST widget ONLY inside productInfo
    var mstWidget = findMSTWidgetInProduct(productInfo);

    // Build drawer content
    buildDrawerContent(drawerBody, mstWidget);

    var isNotifyMode = false;
    var ignoreNextVariantChange = false;

    function findButton() {
      return productInfo.querySelector('.product-form__submit');
    }

    function getSelectedSoldOutSize() {
      var checkedSoldOut = productInfo.querySelectorAll('.product-option__input:checked[data-sold-out="true"]');
      var values = [];
      var seen = {};
      checkedSoldOut.forEach(function(input) {
        var val = input.value;
        if (!seen[val]) {
          seen[val] = true;
          values.push(val);
        }
      });
      return values.join(' / ');
    }

    function getProductTitle() {
      var el = productInfo.querySelector('.product__title');
      return el ? el.textContent.trim() : '';
    }

    function updateDrawerInfo() {
      var infoEl = drawerBody.querySelector('#notify-drawer-product-info');
      if (!infoEl) return;
      var title = getProductTitle();
      var size = getSelectedSoldOutSize();
      infoEl.innerHTML =
        '<p class="notify-form__product-title">' + esc(title) + '</p>' +
        (size
          ? '<p class="notify-form__product-size">Size: <strong>' + esc(size) + '</strong> — Sold Out</p>'
          : '<p class="notify-form__product-size">Currently sold out</p>');
    }

    function enterNotifyMode() {
      isNotifyMode = true;
      var btn = findButton();
      if (!btn) return;

      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.add('product-form__submit--notify-me');

      var span = btn.querySelector('span');
      if (span) {
        span.textContent = NOTIFY_TEXT;
        span.classList.remove('hidden');
      }

      var soldOutMsg = btn.querySelector('.sold-out-message');
      if (soldOutMsg) soldOutMsg.classList.add('hidden');

      btn.removeEventListener('click', onNotifyClick, true);
      btn.addEventListener('click', onNotifyClick, true);

      var dynamic = productInfo.querySelector('.product-form__dynamic-checkout') || productInfo.querySelector('.shopify-payment-button');
      if (dynamic) dynamic.style.display = 'none';
      var staticBtn = productInfo.querySelector('.product-form__buy-now');
      if (staticBtn) staticBtn.style.display = 'none';

      updateDrawerInfo();
    }

    function exitNotifyMode() {
      isNotifyMode = false;
      var btn = findButton();
      if (!btn) return;

      btn.classList.remove('product-form__submit--notify-me');
      btn.removeEventListener('click', onNotifyClick, true);

      // Do NOT call toggleSubmitButton here — the theme's own handleUpdateProductInfo
      // already sets the correct disabled/enabled state and button text.
      // Calling it here on a 200ms delay caused a race condition where the button
      // would get re-enabled during a subsequent variant's fetch.

      // Only show checkout buttons if the variant is NOT preorder
      var productForm = btn.closest('product-form');
      var isPreorder = productForm && productForm.hasAttribute('data-has-pre-order');
      var dynamic = productInfo.querySelector('.product-form__dynamic-checkout') || productInfo.querySelector('.shopify-payment-button');
      if (dynamic) dynamic.style.display = isPreorder ? 'none' : '';
      var staticBtn = productInfo.querySelector('.product-form__buy-now');
      if (staticBtn) staticBtn.style.display = isPreorder ? 'none' : '';

      if (drawer.classList.contains('is-open')) closeDrawer(drawer);
    }

    function onNotifyClick(e) {
      if (!isNotifyMode) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      updateDrawerInfo();
      openDrawer(drawer);
    }

    // Variant clicks
    productInfo.addEventListener('click', function(e) {
      var label = e.target.closest('.product-option__label');
      if (!label) return;
      var input = label.previousElementSibling;
      if (!input || !input.classList.contains('product-option__input')) return;

      if (input.dataset.soldOut === 'true') {
        ignoreNextVariantChange = false;
        setTimeout(function() {
          enterNotifyMode();
          openDrawer(drawer);
        }, 400);
      } else {
        ignoreNextVariantChange = true;
        setTimeout(function() {
          exitNotifyMode();
          ignoreNextVariantChange = false;
        }, 400);
      }
    });

    // PUB_SUB
    var _notifyTimeout = null;
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        var data = event.data;
        if (!data || !data.variant) return;
        // Cancel any previous pending timeout to prevent stale state changes
        if (_notifyTimeout) {
          clearTimeout(_notifyTimeout);
          _notifyTimeout = null;
        }
        _notifyTimeout = setTimeout(function() {
          _notifyTimeout = null;
          if (!data.variant.available && !ignoreNextVariantChange) {
            enterNotifyMode();
          } else if (data.variant.available) {
            exitNotifyMode();
          }
        }, 200);
      });
    }

    // Initial state
    var checked = productInfo.querySelectorAll('.product-option__input:checked[data-sold-out="true"]');
    if (checked.length > 0) enterNotifyMode();
  }

  /**
   * Find MST app widget ONLY inside the product-info element.
   * Skips Loox/reviews blocks.
   */
  function findMSTWidgetInProduct(productInfo) {
    var appBlocks = productInfo.querySelectorAll('.product__app-block');
    for (var i = 0; i < appBlocks.length; i++) {
      var html = appBlocks[i].innerHTML.toLowerCase();
      if (html.includes('loox') || html.includes('review')) continue;
      return appBlocks[i];
    }
    return null;
  }

  /**
   * Build drawer body: product info + description + MST widget + disclaimer
   */
  function buildDrawerContent(drawerBody, mstWidget) {
    var infoWrapper = document.createElement('div');
    infoWrapper.className = 'notify-form__product';
    infoWrapper.id = 'notify-drawer-product-info';

    var descWrapper = document.createElement('div');
    descWrapper.className = 'notify-form__description';
    descWrapper.innerHTML = '<p>Enter your email below and we\'ll notify you when this item is back in stock.</p>';

    var disclaimer = document.createElement('p');
    disclaimer.className = 'notify-form__disclaimer';
    disclaimer.textContent = DISCLAIMER;

    drawerBody.innerHTML = '';
    drawerBody.appendChild(infoWrapper);
    drawerBody.appendChild(descWrapper);

    if (mstWidget) {
      mstWidget.style.display = 'block';
      drawerBody.appendChild(mstWidget);
    }

    drawerBody.appendChild(disclaimer);
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
